import React from 'react';
import { motion } from 'framer-motion';
import { Compass } from 'lucide-react';
export function InsideLook() {
  const benefits = [{
    icon: '⚔️',
    text: 'Narración envolvente'
  }, {
    icon: '🏛️',
    text: 'Ilustraciones exclusivas'
  }, {
    icon: '🦅',
    text: 'Curiosidades sorprendentes'
  }, {
    icon: '📜',
    text: 'Mapas y cronologías'
  }, {
    icon: '👑',
    text: 'Grandes emperadores'
  }, {
    icon: '🛡️',
    text: 'Batallas legendarias'
  }];
  return <section className="py-20 md:py-32 px-4 bg-dark-card/30 relative overflow-hidden" data-id="element-172">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold/20 to-transparent" data-id="element-173" />

      <div className="max-w-4xl mx-auto" data-id="element-174">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-175">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold/10 mb-6" data-id="element-176">
            <Compass className="w-8 h-8 text-gold" data-id="element-177" />
          </div>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-white mb-8" data-id="element-178">
            Una colección creada para vivir Roma como nunca antes
          </h2>
          <div className="text-lg md:text-xl text-text-secondary space-y-6 max-w-3xl mx-auto text-left" data-id="element-179">
            <p data-id="element-180">No se trata de un libro de historia tradicional.</p>
            <p data-id="element-181">
              <strong data-id="element-182">Imperio Romano Legendario</strong> fue diseñado para que
              cada página se sienta como un documental premium.
            </p>
            <p data-id="element-183">
              Descubrirás curiosidades sorprendentes, batallas épicas,
              emperadores legendarios, conspiraciones políticas, gladiadores,
              monumentos, mapas y misterios que hicieron del Imperio Romano una
              de las civilizaciones más extraordinarias de todos los tiempos.
            </p>
            <p data-id="element-184">
              Todo presentado con un estilo visual atractivo, fácil de leer y
              pensado para despertar la curiosidad desde la primera hasta la
              última página.
            </p>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-16" data-id="element-185">
          {benefits.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-dark border border-dark-border p-6 rounded-xl flex items-center gap-4 hover:border-gold/30 transition-colors" data-id="element-186">
              <span className="text-3xl" data-id="element-187">{item.icon}</span>
              <p className="text-text-main font-semibold text-lg leading-relaxed" data-id="element-188">
                {item.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}